import React from 'react';
import { SmartContainer } from '../../../styles/Containers';
import { useEngagementTotal } from './redux/userengagement.actions';
export const TotalEngagement = ({ asset, engagement }) => {

    const { totalLoading, total } = useEngagementTotal({ modelId: asset?.id, engagement })
    if (totalLoading) return null

    return (<span data-total>{total}</span>)

}